import domReady from '@wordpress/dom-ready';
import SiteHeader from './site/shared/site-header/site-header';
import scrollbarWidthDetection from './site/utils/scrollbar-width-detection';
import osBrowserDetection from './site/utils/os-browser-detection';
import touchDeviceDetection from './site/utils/touch-device-detection';
import detectMainNavigationState from './site/main-navigation/main-navigation';
import AnchorScroller from './site/components/anchor-scroll';
import './site/components/highlight';

domReady(() => {
    // Inject scrollbar width CSS variable on root node
    scrollbarWidthDetection();

    // Detect device used by the user
    osBrowserDetection();
    
    // Detect if device can use touch events
    touchDeviceDetection();

    // Detect main navigation state and apply classes to the root node
    detectMainNavigationState();
    
    // Initialize the site header
    const siteHeader = document.querySelector('.site-header');

    if(siteHeader) {
        new SiteHeader(siteHeader, 10);
    }

    const homeAnchor = document.querySelector('a[href="#map"');
    if(homeAnchor) {
        new AnchorScroller('a[href="#map"]', '#map', 200);
    }
    

    // Remove margins added by Gutenberg on headers wrappers nodes
    document.querySelectorAll('.site-header, .site-header-mobile').forEach((header) => {
        const headerWpWrapper = header.closest('.wp-block-template-part');
        if(headerWpWrapper) {
            headerWpWrapper.style.margin = 0;
        }
    });
    
}); 


